import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import { Toast } from 'app/shared/toast/toast';
import { AdminApi } from '../admin-api';

@Component({
  selector: 'app-rename-pdf-template-dialog',
  templateUrl: './rename-pdf-template-dialog.component.html',
  styleUrls: ['./rename-pdf-template-dialog.component.css']
})
export class RenamePdfTemplateDialogComponent {

   error: any;
   title: string;

  constructor(private translate: TranslateService, @Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<RenamePdfTemplateDialogComponent>,private toast: Toast, private api: AdminApi) {
   this.title = data?.templateInfo?.templateName
      ? data.templateInfo.templateName.replace(/\.pdf$/i, '')
      : '';

  }

   onClickRename(templateName: HTMLInputElement) {
      const oldValue = this.data.templateInfo.templateName.replace(/\.pdf$/i, '').trim();
      const newValue = templateName.value.trim();

      if (newValue === (oldValue || '').trim()) {
         this.dialogRef.close({ response: false });
         return;
      }
      if (templateName.value.trim().length === 0) {
         templateName.focus();
         return;
      }
      if (/[<>\\\/:?*"]/g.test(templateName.value)) {
         this.translate.get('e-form.errors.invalid-fileName').subscribe((s) => {
            this.error = s;
         });
         templateName.focus();
         return;
      }
      if (templateName.value.lastIndexOf('.') === templateName.value.length - 1) {
         this.translate.get('pdf-template.alert.create_pdf_template_error_dot').subscribe((s) => {
            this.toast.error(s);
         });
         return;
      }
      const newTemplateName = templateName.value + '.pdf';
      this.api.renamePdfTemplate(this.data.templateInfo.templateId, this.data.templateInfo.alfId, newTemplateName).subscribe(
         (res) => {
            this.dialogRef.close({response: true, msg: res});
         },
         (error) => {
            this.handleErrors(error);
            templateName.focus();
         }
      );
   }

   handleErrors(e: any) {
      if (e.status === 404) {
         this.toast.error('Service Not Found.');
      }
   }

}
